<script setup lang="ts">
import { FormLabel, FormInput } from "../../../base-components/Form";
import LoadingIcon from "../../../base-components/LoadingIcon";
import Button from "../../../base-components/Button";
import Preview from "../../../base-components/Preview";
import { computed, ref } from "vue";
import { reactive, toRefs } from "vue";
import { required, minLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import { storeToRefs } from "pinia";
import { useMensajesStore } from "../../../services/mensajes";
import { useProductosCategoriasStore } from "../../../services/productosCategorias";
import { CategoriaProductos } from "@fixeduy/restaurantestypes";
import { utilFechaGetCurrentTime } from "../../../utils/fecha";

const mensajesStore = useMensajesStore();
const ProductosCategoriasStore = useProductosCategoriasStore();
const { categorias } = storeToRefs(ProductosCategoriasStore);
const categoriasActivos = computed(() => {
  return categorias.value.filter(categoria => categoria.activo);
});
// const { addCategoria } = ProductosCategoriasStore;
const cargando = ref(false);

const emit = defineEmits<{
  (e: "cancelar"): void;
  (e: "exito"): void;
}>();

const formData = reactive({
  codigo: "",
  nombre: ""
});

const rules = {
  codigo: {},
  nombre: {
    required: helpers.withMessage("El campo no puede estar vacío", required)
  }
};
const validate = useVuelidate(rules, toRefs(formData));

const handlerCreate = async () => {
  const result = await validate.value.$validate();

  if (!result) return;

  cargando.value = true;
  try {
    let categoria: CategoriaProductos = {
      id: "",
      version: 1,
      codigo: formData.codigo,
      nombre: formData.nombre,
      activo: true,
      ultimaEdicion: utilFechaGetCurrentTime()
    };
    const ok = await ProductosCategoriasStore.crearCategoria(categoria);
    if (ok) {
      mensajesStore.mostrarToast(
        "Categoría creada",
        `Se ha agregado la categoría "${formData.nombre.trim()}".`,
        mensajesStore.mensajeType.exito
      );
      emit("exito");
    } else {
      mensajesStore.mostrarModal(
        "Error",
        "No se pudo crear la categoría. Intentá de nuevo.",
        mensajesStore.mensajeType.error
      );
    }
  } finally {
    cargando.value = false;
  }
};
</script>

<template>
  <Preview class="box mt-5">
    <form class="validate-form p-4" @submit.prevent="handlerCreate">
      <div
        class="border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400"
      >
        <!-- <h2 class="mr-auto text-lg font-medium">Agregar categoria</h2> -->
        <div class="col-span-12 lg:col-span-6">
          <!-------------------- Codigo ------------------------>
          <!-- <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel
                htmlFor="horizontal-form-1"
                class="w-16 md:w-40 sw:w-20"
              >
                Código
              </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="validate.codigo.$model"
                :class="{
                  'border-danger': validate.codigo.$error
                }"
                placeholder="Código"
              />
              <template v-if="validate.codigo.$error">
                <div
                  v-for="(error, index) in validate.codigo.$errors"
                  :key="index"
                  class="mt-2 text-danger"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
          </div> -->
          <!-------------------- Nombre ------------------------>
          <div class="flex mt-5">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel
                htmlFor="horizontal-form-1"
                class="w-16 md:w-40 sw:w-20"
              >
                Nombre
              </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="validate.nombre.$model"
                :class="{
                  'border-danger': validate.nombre.$error
                }"
                placeholder="Nombre"
              />
              <template v-if="validate.nombre.$error">
                <div
                  v-for="(error, index) in validate.nombre.$errors"
                  :key="index"
                  class="mt-2 text-danger"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-if="!cargando" class="flex mt-6">
          <div class="flex-1 text-left">
            <Button
              variant="secondary"
              class="mb-2 mr-1"
              @click="
                () => {
                  emit('cancelar');
                }
              "
            >
              Cancelar</Button
            >
          </div>
          <div class="flex-1 text-right">
            <Button variant="primary" class="mb-2 mr-1 submary" type="submit">
              Crear nueva categoría
            </Button>
          </div>
        </div>
        <div v-else class="flex my-6">
          <div class="mx-auto">
            <LoadingIcon icon="oval" class="w-8 h-8" />
          </div>
        </div>
      </div>
    </form>
  </Preview>
</template>
